import { render, staticRenderFns } from "./RdBorderCardUpsell.vue?vue&type=template&id=2f62e484"
import script from "./RdBorderCardUpsell.vue?vue&type=script&lang=ts"
export * from "./RdBorderCardUpsell.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports